module.exports = __webpack_public_path__ + "static/media/petr-a-pavel.f98acc9d.jpg";